import React, { useState, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';
import styled, { withTheme } from 'styled-components';
import { message, Modal, Upload, Divider } from 'antd'
import { Text } from '../../../Reusable/Text';
import { ErrorAlert } from '../../../Reusable/Alert'
import { TextButton, Button } from '../../../Reusable/Button';
import { Image } from '../../../Reusable/Image';
import { apiPOSTReq } from '../../../../Utils/api'
import { CardContainer, FlexColumn, Flex } from '../../../Reusable/Container';
import UploadIcon from '../../../../Images/upload-cloud.svg'
import environment from '../../../../environment'
import { addDataToStore, UPDATE_LOGO } from '../../../../Actions/actions';
import { ErrorLabel, LabeledInput } from '../../../Reusable/Input'
import { displayName } from 'react-world-flags';

const { Dragger } = Upload

export const StyledDragger = styled(Dragger)`
    .ant-upload.ant-upload-drag {
        background: #F8F8F9 !important;
        border: 1px dashed #7384AA !important;
        border-radius: 8px !important;
        max-width: 370px;
    }
`;

const PaymentLinkModal = ({ edit, aionStore, onUpload, onCancel, customer }) => {
    const [loading, setLoading] = useState()
    const [logoUrl, setLogoUrl] = useState(null)
    const [error, setError] = useState(false)
    const [email, setEmail] = useState(customer?.primaryEmailAddress?.address)
    const [feeLabel, setFeeLabel] = useState()
    const [errorField, setErrorField] = useState();

    const emailRef = useRef();

    const history = useHistory()

    const dispatch = useDispatch();

    const uploadProps = {
        action: `${environment.apiBaseUrl}/file/upload`,
        headers: {
            businesskey: aionStore.BusinessUniqueKey,
            type: "logo",
            jwt: aionStore.jwt
        },
        onChange: (info) => {
            var { fileList } = info;
            fileList.forEach(file => {
                const { status, response, name, url } = file;
                console.log("fileList response", response);
                if (status === "done") {
                    onUpload((response.UploadedUrls || [])[0])
                    setLogoUrl((response.UploadedUrls || [])[0])
                    // this.setState({
                    //     logoUrl: (response.UploadedUrls || [])[0],
                    //     showLogoModal: false,
                    // }, () => this.saveLogoUrl());
                }
            });
        }
    };

    var { business } = aionStore
    var { businessInfo } = business.businessProfile || {}
    businessInfo = businessInfo || {}
    const imageUrl = businessInfo.logoUrl

    var imgStyle = { height: 48, width: 48, objectFit: "contain", borderRadius: "5px" }

    const saveLogoUrl = () => {
        if(!email || email === "") {
            setErrorField("email")
            return
        } 
        if(!feeLabel || feeLabel === "") {
            setErrorField("feeLabel")
            return
        } 
        if (logoUrl) {
            setLoading(true)
            apiPOSTReq(`${environment.uamBaseUrl}/user/admin/updateLogo`, null, { logoUrl: logoUrl }, (err, resp) => {
                try {
                    const data = resp || {};
                    console.log("/updateLogo", logoUrl, data)
                    if (data.result) {
                        // Update business profile
                        dispatch(addDataToStore(UPDATE_LOGO, logoUrl));
                        onConfirm()
                    } else {
                        throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                    }
                } catch (error) {
                    console.log("ERRR updateLogo", error, err, resp)
                    ErrorAlert({ description: error.message })
                } finally {
                    setLoading(false)
                }
            })
        } else onConfirm()
    }

    const onConfirm = () => {
        var paymentConfirmationRequests = [];
        paymentConfirmationRequests.push({
            CustomerId: customer?.customerId,
            ToAddr: email,
            displayName: customer?.displayName,
        })

        history.push({
            pathname: '/receivables/customers/send-payment-notification',
            state: { customers: paymentConfirmationRequests, feeLabel, logoUrl: logoUrl || imageUrl }
        })
    }

    return (
        <FlexColumn start gap='24px'>
            <Text heading>Send payment link</Text>

            <LabeledInput
                inputRef={emailRef}
                nomargin
                label="Email"
                type="email"
                id="primaryEmailAddress"
                key="primaryEmailAddress"
                // width="284px"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="Email"
                error={errorField === "email"}
                errorMessage={"Email is a required field"}
            />

            <LabeledInput
                label="Fee label"
                id="feeLabel"
                key="feeLabel"
                placeholder="E.g. Launch fee or Billing Setup Fee"
                value={feeLabel}
                onChange={(event) => setFeeLabel(event.target.value)}
                nomargin
                error={errorField === "feeLabel"}
                errorMessage={"Fee Label is a required field"}
            />

            <Text margin='0 0 12px' size="16px">Logos should be at least 600x600 and will be visible to your team members and optionally visible on invoices.</Text>

            <Flex start centerHorizontally gap="12px" fullWidth>
                {
                    (logoUrl || imageUrl) && <img src={logoUrl || imageUrl} style={imgStyle} />
                }

                <Text size="16px" weight="500">{(businessInfo.name || "").trim()}</Text>
            </Flex>

            <FlexColumn start gap='4px' style={{ maxWidth: 570, marginBottom: 24 }}>
                <Text color={'#7384AA'} size='14px' weight={400}>Upload new logo</Text>
                <Flex end fullWidth>
                    <StyledDragger {...uploadProps}>
                        <Flex start center style={{ width: 570, height: 90, maxWidth: 570 }} gap='16px'>
                            <Image src={UploadIcon} width='36px' height='36px' />
                            <FlexColumn start left gap='4px'>
                                <Text size='16px' weight='500'>Drag and drop here or click to upload.</Text>
                                <Text>You may upload PNG or JPEG files</Text>
                            </FlexColumn>
                        </Flex>
                    </StyledDragger>
                </Flex>
                {error && <ErrorLabel>Please upload a logo</ErrorLabel>}
            </FlexColumn>

            <Flex end gap='24px' centerHorizontally>
                <TextButton text='Cancel' onClick={onCancel} />
                <Button text='Confirm' solid primary onClick={() => {
                    if (logoUrl || imageUrl) saveLogoUrl()
                    else setError(true)
                }} loading={loading} />
            </Flex>
        </FlexColumn>
    );
};


function mapStateToProps(state) {
    return {
        aionStore: state.aionAppReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(PaymentLinkModal)));
